type HX = 'h1' | 'h2' | 'h3' | 'h4';

type headingX =
  | 'heading-one'
  | 'heading-two'
  | 'heading-three'
  | 'heading-four';

export const getPlaceholderText = (hX: HX, headingX) => {
  return `<${hX} data-type="${headingX}"><p data-type="paragraph"><strong data-type="bold">${hX?.toUpperCase()}</strong> Heading example</p></${hX}><p data-type="paragraph"></p><p data-type="paragraph">Body copy text example set to P</p>`;
};
